module.exports = __webpack_public_path__ + "static/media/gcdef_10051.2207cb69.ico";